module.exports = __webpack_public_path__ + "static/img/4.8c87301.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/4.jpg
// module id = qWOj
// module chunks = 1